<template>
  <div class="usc-table gutter-lg mb">
    <h3>{{title}}</h3>
    <slot name="body"></slot>
    <table>
      <tr v-for="(d, index) in data">
        <td>{{ d.left }}</td>
        <td>{{ d.right }}</td>
      </tr>
    </table>
    <p class="disclaimer">{{ disclaimer }}</p>
  </div>
</template>

<script>
export default {
  name: 'Table',
  props: ['title', 'data', 'disclaimer'],
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';

  .usc-table {

    h3 {
      margin-bottom: 25px;
      color: #323233;
    }

    table {
      width: 100%;
      margin-bottom: 25px;
    }
    td {
      font-size: 17px;
      height: 30px;
      &:first-of-type {
        text-align: left;
      }
      &:last-of-type {
        text-align: right;
      }
    }

    p.disclaimer {
      font-size: 15px;
      color: #707070;
      font-style: italic;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Table.vue